<div class="brand__nametag">EGIS</div>
<nav class="site-nav__wrap">
  <div class="site-nav__top">
    <a routerLink="/aftale" matTooltip="Gå til forsiden" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <mat-icon svgIcon="home"></mat-icon>
      <span>Aftaler</span>
    </a>
    <a routerLink="/ordre" matTooltip="Ordrer" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <mat-icon svgIcon="document"></mat-icon>
      <span>Ordrer</span>
    </a>
    <a
      [routerLink]="showStatusMenuItem ? '/opfoelgning/dashboard' : '/opfoelgning/aftale'"
      matTooltip="Mine opfølgninger"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: false }"
    >
      @if (antalOpfoelgningerPastDeadline > 0) {
        <mat-icon svgIcon="bookmark" [matBadge]="antalOpfoelgningerPastDeadline" matBadgeColor="primary" matBadgeSize="small">
          <span class="icon-center-badge">{{ antalOpfoelgninger }}</span>
        </mat-icon>
      }
      @if (antalOpfoelgningerPastDeadline === 0) {
        <mat-icon svgIcon="bookmark"></mat-icon>
      }
      @if (antalOpfoelgningerPastDeadline === 0) {
        <span class="icon-center-badge">{{ antalOpfoelgninger }}</span>
      }
      <span>Opfølgninger</span>
    </a>
    @if (showSlutopgoerelser) {
      <a
        routerLink="/slutopgoerelser"
        matTooltip="Overskredne Slutopgørelser"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        @if (antalSlutopgoerelser > 0) {
          <mat-icon svgIcon="bookmark" [matBadge]="antalSlutopgoerelser" matBadgeColor="primary" matBadgeSize="small"></mat-icon>
        }
        @if (antalSlutopgoerelser === 0) {
          <mat-icon svgIcon="calc"></mat-icon>
        }
        <span>Slutopgørelser</span>
      </a>
    }
  </div>
  <div class="site-nav__bottom">
    @if (showSettings) {
      <a
        routerLink="/indstillinger"
        matTooltip="Indstillinger"
        class="cursor-pointer"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <mat-icon>settings</mat-icon>
        <span>Indstillinger</span>
      </a>
    }
    @if (showErrorDashboard) {
      <app-fejl-dashboard-ikon></app-fejl-dashboard-ikon>
    }
    <a matTooltip="Profil" class="cursor-pointer" [matMenuTriggerFor]="menu">
      <mat-icon svgIcon="avatar"></mat-icon>
      <span>Profil</span>
    </a>
    <mat-menu #menu="matMenu">
      <a mat-menu-item (click)="logOut()">
        <mat-icon aria-hidden="false" aria-label="Log ud" svgIcon="logout"></mat-icon>
        <span>Log ud</span>
      </a>
      @if (showStatusMenuItem) {
        <a mat-menu-item routerLink="/systemstatus">
          <span>Status</span>
        </a>
      }
      <hr />
      <app-version></app-version>
    </mat-menu>
  </div>
</nav>
